"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEPHSReviewComponent = void 0;
const core_1 = require("@angular/core");
const expresspay_services_1 = require("../../../shared/services/expresspay.services");
const helper_service_1 = require("../../../../mma/shared/services/helper.service");
const shared_1 = require("../../../../mma/shared");
const _ = require("underscore");
class CSEPHSReviewComponent {
    constructor(expressPayService, helperService, genericContentService) {
        this.expressPayService = expressPayService;
        this.helperService = helperService;
        this.genericContentService = genericContentService;
        this.edit = new core_1.EventEmitter();
        this.next = new core_1.EventEmitter();
        this.paymentType = new core_1.EventEmitter();
        this.confirmationNumber = new core_1.EventEmitter();
        this.genericError904 = new core_1.EventEmitter();
        this.confirmationInfo = new core_1.EventEmitter();
        this.classes = 'col-12';
        this.cardMonth = [
            '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'
        ];
        this.cardYear = [
            '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027'
        ];
        this.goToMyExpressPay = function () {
            this.helperService.onNavigate('/my_account/personal/express-pay/');
        };
        this.scrollTop();
    }
    ngOnInit() {
        this.disablePaymentButton = false;
        this.payAmount = true;
        this.paymentMethod = this.paymentMethodData.setPaymentMethod;
        // to check if the user has valid session or not
        this.isAuthenticated();
        this.getTermsAndCondition();
        this.getSessionId();
        if (this.convenienceAmount && this.convenienceAmount > 0) {
            this.totalPaymentAmount = this.funds.amountToPay + this.convenienceAmount;
        }
        else {
            this.totalPaymentAmount = this.funds.amountToPay;
        }
    }
    editPaymentInfo() {
        this.paymentDetails = null;
        this.funds = null;
        this.giftCardData = null;
        this.bankAccountDetails = null;
        this.edit.emit(true);
    }
    getTermsAndCondition() {
        this.genericContentService.getGenericContent('/generic/agreement/draftEFTTerms').subscribe((data) => {
            this.termsAndConditionInfo = data.contentText;
        }, (err) => {
            this.error = err;
        });
    }
    submit(reviewPaymentDetails) {
        this.disablePaymentButton = true;
        this.error = null;
        this.scrollTop();
        this.paymentMethod = this.paymentMethodData.setPaymentMethod;
        if (this.paymentMethodData.setPaymentMethod === 'GIFT_CARD') {
            this.giftCardData.termsAndConditions = reviewPaymentDetails.termscondition;
            this.loader = true;
            this.expressPayService.submitPaymentByGiftCardHS(this.giftCardData).subscribe((data) => {
                this.loader = false;
                this.paymentType.emit(this.paymentMethod);
                this.confirmationNumber.emit(data.authCode);
                this.next.emit(true);
            }, (err) => {
                this.handleSubmitError(err);
            });
        }
        else if (this.paymentMethodData.setPaymentMethod === 'BANK_ACCOUNT') {
            let content = {};
            content = this.payByBankAccount(this.bankAccountDetails, this.funds, reviewPaymentDetails);
            this.loader = true;
            this.expressPayService.submitBankAccountDetailsHS(content).subscribe((data) => {
                this.loader = false;
                this.confirmationNumber.emit(data.authCode);
                this.paymentType.emit(this.paymentMethod);
                this.next.emit(true);
            }, (err) => {
                this.handleSubmitError(err);
            });
        }
        else {
            const ccContents = this.payByCreditCard(this.ccContentData, reviewPaymentDetails);
            this.loader = true;
            this.expressPayService.submitCreditCardDetailsHS(ccContents).subscribe((res) => {
                this.loader = false;
                this.confirmationNumber.emit(res.authCode);
                this.paymentType.emit(this.paymentMethod);
                this.genericError904.emit(res.errorIdOnPaymentSuccess);
                this.next.emit(true);
            }, (err) => {
                this.handleSubmitError(err);
            });
        }
    }
    handleSubmitError(err) {
        this.disablePaymentButton = false;
        this.loader = false;
        this.error = err;
        this.scrollTop();
    }
    payByCreditCard(ccContent, reviewPaymentDetails) {
        // let content = {};
        ccContent.termsAndConditions = reviewPaymentDetails.termscondition;
        ccContent.email = reviewPaymentDetails.email;
        ccContent.convenienceFeeAmount = this.convenienceAmount;
        return ccContent;
    }
    payByBankAccount(details, funds, reviewPaymentDetails) {
        details.termsAndConditions = reviewPaymentDetails.termscondition;
        details.email = reviewPaymentDetails.email;
        return details;
    }
    getSessionId() {
        this.expressPayService.getSessionId().subscribe((res) => {
            this.riskSessionIdUrl = '/global/logo.jsp?sessionId=' + res.riskSessionId;
        }, (err) => {
            this.error = err;
        });
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    scrollTop() {
        window.scrollTo(0, 200);
    }
    // code to check if the user has valid session or not
    isAuthenticated() {
        this.loader = true;
        this.expressPayService.loginAuthentication().subscribe((data) => {
            if (_.isEmpty(data)) {
                this.hidePage = true;
                this.helperService.onNavigate('/my_account/personal/express-pay/');
            }
            this.loader = false;
        }, (err) => {
            this.loader = false;
        });
    }
}
exports.CSEPHSReviewComponent = CSEPHSReviewComponent;
//# sourceMappingURL=review.component.js.map